import { brandPalette, secondaryPalette } from './palette'

/**
 * Any values that aren't sensitive and don't change between deployments
 * (otherwise they belong in .env)
 */

/**
 * Number of quotes allowed on trial accounts
 */
export const TRIAL_QUOTE_LIMIT = 15

/**
 * Number of files allowed on a quote
 */
export const TRIAL_QUOTE_FILES_LIMIT = 5

/**
 * REGEX to match valid UUID
 */
export const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i

/**
 * Our curreent quote version
 */
export const CURRENT_QUOTE_VERSION = 12

/**
 * Corrective constant for rounding re: https://github.com/PaintScout/PaintScout/issues/11821
 */
export const CORRECTIVE_CONSTANT = 0.0000000001 // Adjusts for odd floating point behavior

export const USER_COLOR_MAP = {
  [secondaryPalette['20'].C60]: { light: secondaryPalette['20'].C90, dark: secondaryPalette['20'].C30 },
  [secondaryPalette['50'].C60]: { light: secondaryPalette['50'].C90, dark: secondaryPalette['50'].C30 },
  [secondaryPalette['80'].C60]: { light: secondaryPalette['80'].C90, dark: secondaryPalette['80'].C30 },
  [secondaryPalette['110'].C60]: { light: secondaryPalette['110'].C90, dark: secondaryPalette['110'].C30 },
  [secondaryPalette['140'].C60]: { light: secondaryPalette['140'].C90, dark: secondaryPalette['140'].C30 },
  [secondaryPalette['170'].C60]: { light: secondaryPalette['170'].C90, dark: secondaryPalette['170'].C30 },
  [secondaryPalette['200'].C60]: { light: secondaryPalette['200'].C90, dark: secondaryPalette['200'].C30 },
  [secondaryPalette['230'].C60]: { light: secondaryPalette['230'].C90, dark: secondaryPalette['230'].C30 },
  [secondaryPalette['260'].C60]: { light: secondaryPalette['260'].C90, dark: secondaryPalette['260'].C30 },
  [secondaryPalette['290'].C60]: { light: secondaryPalette['290'].C90, dark: secondaryPalette['290'].C30 },
  [secondaryPalette['320'].C60]: { light: secondaryPalette['320'].C90, dark: secondaryPalette['320'].C30 },
  [secondaryPalette['350'].C60]: { light: secondaryPalette['350'].C90, dark: secondaryPalette['350'].C30 }
}

export const USER_COLOR_PALETTE = [
  secondaryPalette['260'].C60,
  secondaryPalette['140'].C60,
  secondaryPalette['50'].C60,
  secondaryPalette['290'].C60,
  secondaryPalette['230'].C60,
  secondaryPalette['170'].C60,
  secondaryPalette['350'].C60,
  secondaryPalette['110'].C60,
  secondaryPalette['200'].C60,
  secondaryPalette['20'].C60,
  secondaryPalette['80'].C60,
  secondaryPalette['320'].C60
]

export const USER_COLOR_PALETTE_CHROMA_ORDER = [
  secondaryPalette['20'].C60,
  secondaryPalette['50'].C60,
  secondaryPalette['80'].C60,
  secondaryPalette['110'].C60,
  secondaryPalette['140'].C60,
  secondaryPalette['170'].C60,
  secondaryPalette['200'].C60,
  secondaryPalette['230'].C60,
  secondaryPalette['260'].C60,
  secondaryPalette['290'].C60,
  secondaryPalette['320'].C60,
  secondaryPalette['350'].C60
]

export const TAG_COLORS = [
  [brandPalette.Neutral.P60, brandPalette.Neutral.P96],
  [secondaryPalette['20'].C60, secondaryPalette['20'].C95],
  [secondaryPalette['50'].C60, secondaryPalette['50'].C95],
  [secondaryPalette['80'].C60, secondaryPalette['80'].C95],
  [secondaryPalette['110'].C60, secondaryPalette['110'].C95],
  [secondaryPalette['140'].C60, secondaryPalette['140'].C95],
  [secondaryPalette['170'].C60, secondaryPalette['170'].C95],
  [secondaryPalette['200'].C60, secondaryPalette['200'].C95],
  [secondaryPalette['230'].C60, secondaryPalette['230'].C95],
  [secondaryPalette['260'].C60, secondaryPalette['260'].C95],
  [secondaryPalette['290'].C60, secondaryPalette['290'].C95],
  [secondaryPalette['320'].C60, secondaryPalette['320'].C95],
  [secondaryPalette['350'].C60, secondaryPalette['350'].C95],
  [brandPalette.Neutral.P40, brandPalette.Neutral.P94]
].map((pair) => {
  return [pair[0].toUpperCase(), pair[1].toUpperCase()]
})

export const CREW_COLORS = [
  [secondaryPalette['20'].C60, secondaryPalette['20'].C95],
  [secondaryPalette['50'].C60, secondaryPalette['50'].C95],
  [secondaryPalette['80'].C60, secondaryPalette['80'].C95],
  [secondaryPalette['110'].C60, secondaryPalette['110'].C95],
  [secondaryPalette['140'].C60, secondaryPalette['140'].C95],
  [secondaryPalette['170'].C60, secondaryPalette['170'].C95],
  [secondaryPalette['200'].C60, secondaryPalette['200'].C95],
  [secondaryPalette['230'].C60, secondaryPalette['230'].C95],
  [secondaryPalette['260'].C60, secondaryPalette['260'].C95],
  [secondaryPalette['290'].C60, secondaryPalette['290'].C95],
  [secondaryPalette['320'].C60, secondaryPalette['320'].C95],
  [secondaryPalette['350'].C60, secondaryPalette['350'].C95]
].map((pair) => {
  return [pair[0].toUpperCase(), pair[1].toUpperCase()]
})

// going to try not using these for now, rainbow calendar/user colors above only
// export const USER_ACTIVITY_COLOR_PALETTE = [
// '#929fb5',
// '#c6cedc',
// '#55647c',
// '#d9dee8',
// '#2e3b51',
// '#e8ebf1',
// '#738198',
// '#b4bed0',
// '#252e3d',
// '#a2afc3',
// '#394860'
// ]
